import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducer from './apple-profile.reducer';
import { AppleProfileState } from './apple-profile.state';

export const selectAppleProfileState = createFeatureSelector<AppleProfileState>('apple-profile');

export const selectProfileIds = createSelector(selectAppleProfileState, fromReducer.selectProfileIds);

export const selectAppleProfileEntities = createSelector(
  selectAppleProfileState,
  fromReducer.selectAppleProfileEntities
);

export const selectAllProfiles = createSelector(selectAppleProfileState, fromReducer.selectAllProfiles);

export const selectSingleAppModeBundleIdentifier = (udid: string) =>
  createSelector(selectAllProfiles, (profiles) => {
    const index = profiles.findIndex(
      (profile) => profile.udid === udid && profile.payloadIdentifier === 'com.methylium.applock'
    );

    return index >= 0
      ? extractBundleIdentifierFromPayloadDisplayName(profiles[index].payloadDisplayName ?? '')
      : undefined;
  });

function extractBundleIdentifierFromPayloadDisplayName(payloadDisplayName: string): string | undefined {
  return payloadDisplayName.startsWith('App Lock for: ') ? payloadDisplayName.substring(14) : undefined;
}
